var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVesselFilterIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.08569 20.2233V20.2233C1.37001 20.2667 1.66079 20.2211 1.9182 20.0928L2.55088 19.7774C3.48555 19.3114 4.57575 19.2713 5.54218 19.6671L6.10695 19.8984C7.05704 20.2876 8.12906 20.2464 9.04654 19.7857V19.7857C9.98252 19.3156 11.0783 19.2827 12.0408 19.6958L13.6021 20.3659",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6164 10.0744L3.88275 11.9505M3.60067 19.4521L1.57144 13.7026C1.37878 13.1568 1.68842 12.5618 2.24604 12.4065L3.88275 11.9505M3.88275 11.9505V7.28597C3.88275 6.73368 4.33046 6.28597 4.88275 6.28597H8.27781M12.9783 6.28597H16.1644C16.7167 6.28597 17.1644 6.73368 17.1644 7.28597V8.48643M12.9783 6.28597V3.6378C12.9783 3.08552 12.5306 2.6378 11.9783 2.6378H9.27781C8.72553 2.6378 8.27781 3.08552 8.27781 3.6378V6.28597M12.9783 6.28597H8.27781M18.0738 11.5821C15.9928 11.5821 14.593 11.8091 13.7504 12.0155C13.2202 12.1454 13.0731 12.7467 13.4257 13.1634L16.7301 17.0685C16.8588 17.2207 16.9294 17.4135 16.9294 17.6128V20.5186C16.9294 21.1449 17.5885 21.5522 18.1487 21.2721L18.7525 20.9702C19.0379 20.8275 19.2182 20.5358 19.2182 20.2167V17.6128C19.2182 17.4135 19.2889 17.2207 19.4176 17.0685L22.7219 13.1634C23.0746 12.7467 22.9275 12.1454 22.3972 12.0155C21.5546 11.8091 20.1548 11.5821 18.0738 11.5821Z",
    stroke: "black",
    strokeWidth: 1.6,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVesselFilterIcon);
export default __webpack_public_path__ + "static/media/vessel-filter-icon.aa5003d7f68817afc2df3661f48751a4.svg";
export { ForwardRef as ReactComponent };